module.exports = __webpack_public_path__ + "files/df074a3edc140ecac8a9cbbc071996ec.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/roboto-italic-webfont.svg
 ** module id = 1004
 ** module chunks = 0
 **/